import React from "react";
import { LinkPreview } from "./ui/link-preview";

function TechJourney() {
    return (
        <div className="flex justify-center items-start h-auto flex-col px-4">
            {/* First paragraph */}
            <p className="text-slate-300 dark:text-neutral-200 text-base text-left mb-2">
                I'm a software engineer who started out building websites and customizing my Tumblr page, and turned that curiosity into a B.S. in Computer Science and a specialization in data analytics.
            </p>

            {/* Second paragraph */}
            <p className="text-slate-300  text-base text-left mb-2">
                My focus is full-stack development with JavaScript, React, and Node.js. On{" "}
                <LinkPreview
                    url="https://greattreads.netlify.app/"
                    imageSrc="/greatsc.png"
                    isStatic
                    className="font-bold text-teal-400 underline cursor-pointer"
                >
                    GreatReads
                </LinkPreview>
                , a book-tracking app, I built RESTful API integrations and session management to handle user authentication and personalized recommendations at scale.
            </p>


            {/* Fourth paragraph */}
            <p className="text-slate-300  text-base text-left mb-2">
                I care about writing code that's clean and maintainable, not just functional — outside of tech, I stay sharp through reading, hiking, and time with family, which keeps me grounded and curious.
            </p>

            {/* Fifth paragraph */}
            <p className="text-slate-300 text-base  text-base text-left">
                Check out my{" "}
                <LinkPreview
                    url="/Muntaqa_Maahi_Resume.pdf"
                    imageSrc="/resumesc.png"  // Correct image path from public folder
                    isStatic
                    className="font-bold text-teal-400 underline cursor-pointer"
                >
                    resume
                </LinkPreview>{" "}
                to learn more about my professional journey, projects, and technical skills.
            </p>
        </div>
    );
}

export default TechJourney;